import CrudTable from "@/components/admin/CrudTable";

export default function AdminProjects() {
  return (
    <CrudTable
      title="Projects"
      testid="admin-projects"
      endpoint="/projects"
      adminEndpoint="/admin/projects"
      columns={[
        { key: "title", label: "Title" },
        { key: "category", label: "Category" },
        { key: "client", label: "Client" },
        { key: "year", label: "Year" },
      ]}
      defaults={{ slug: "", title: "", category: "", client: "", location: "", country: "", year: "", cover_image: "", overview: "", scope: "", challenges: "", solutions: "", gallery: [], featured: false }}
      fields={[
        { name: "slug", label: "Slug (URL)" },
        { name: "title", label: "Title" },
        { name: "category", label: "Category" },
        { name: "client", label: "Client" },
        { name: "location", label: "Location (City, Country)" },
        { name: "country", label: "Country Code (e.g. NG, GH)" },
        { name: "year", label: "Year" },
        { name: "cover_image", label: "Cover Image URL" },
        { name: "hero_image", label: "Hero Image URL (optional)" },
        { name: "overview", label: "Overview", type: "textarea" },
        { name: "scope", label: "Scope", type: "textarea" },
        { name: "challenges", label: "Challenges", type: "textarea" },
        { name: "solutions", label: "Solutions", type: "textarea" },
        { name: "gallery", label: "Gallery Image URLs (one per line)", type: "array" },
        { name: "featured", label: "Featured on home", type: "checkbox" },
      ]}
    />
  );
}
